import SOWRelatedTable from "./SOWRelatedTable/SOWRelatedTable";

import { Sow } from "services/input-core/sows/@types";

type SOWsRelatedProps = {
  sows: Sow[] | [];
  isLoading: boolean;
  isSowAdm: boolean;
};

export default function SOWsRelated({
  sows,
  isLoading,
  isSowAdm,
}: SOWsRelatedProps) {
  return (
    <SOWRelatedTable
      isLoading={isLoading}
      data={sows ?? []}
      isSowAdm={isSowAdm}
    />
  );
}
